import { useContext } from "react";

import { useStore } from "hooks/use-store";
import { ScreenRoutes } from "navigation/routes";
import { MqttClientContext } from "services/mqtt-client";
import ConnectionErrorScreen from "screens/error/connection-error";
import ErrorScreen from "screens/error/error";

export const ScreenContainer = () => {
  const client = useContext(MqttClientContext);
  const screen = useStore((state) => state.screen);

  if (!client?.connected) return <ConnectionErrorScreen />;

  const SelectedScreen = () =>
    ScreenRoutes.find((s) => s.name === screen)?.element ?? <ErrorScreen />;

  return <SelectedScreen />;
};
